import useUrlParams from '../../../../hooks/useUrlParams';
import useContacts from '../../../../hooks/useContacts';
import { SatelliteIcon } from "./Svgs";
import { get_formated_time } from '../../../../utils';
import useScenario from '../../../../hooks/useScenario';
import { isOperateMode } from '../../../../hooks/utils';

// Function to get CSS class based on status
const getStatusClass = (status) => {
  const statusClasses = {
    Error: 'status__error',
    Scheduled: 'status__schedule',
    Active: 'status__active',
    Completed: 'status__success',
  };
  return statusClasses[status] || '';
};

// Function to truncate text to a max length
const truncateText = (text, maxLength = 7) => {
  const str = String(text || '');
  const len = Math.max(1, Number(maxLength) || 7);
  return str.length > len ? `${str.slice(0, len)}...` : str;
};

const ContactAlert = () => {
  const { dashboard } = useUrlParams(); // Fetch URL parameters
  const { contacts } = useContacts(); // Fetch contact data

  // Function to create an alert object from a contact
  const createAlert = (contact, type, statusMap) => {
    try {
      if (!contact) return null;
      
      const startTime = contact.startTime;
      const endTime = contact.endTime;
      const timeValue = type === 'Upcoming' ? startTime : endTime;
      
      return {
        groundstation: contact.groundStationName,
        country: contact.groundStationProperties?.country,
        type: `${type} contact`,
        time: timeValue ? get_formated_time(timeValue) : '',
        duration: startTime && endTime ? Math.floor((endTime - startTime) / 60) : 0,
        status: statusMap[contact.status] || 'Error',
      };
    } catch (error) {
      // Return null if any error occurs, will be filtered out
      return null;
    }
  };

  // Generate alerts based on contact data
  const alerts = [
    ...(contacts?.upcoming_contacts?.slice(0, 1).map(c =>
      createAlert(c, 'Upcoming', { Booked: 'Scheduled', Scheduled: 'Scheduled' })
    ).filter(Boolean) ?? []),
    ...(contacts?.ongoing_contacts?.map(c =>
      createAlert(c, 'Ongoing', { Booked: 'Active', Scheduled: 'Active' })
    ).filter(Boolean) ?? []),
    ...(contacts?.previous_contacts?.slice(0, 1).map(c =>
      createAlert(c, 'Previous', { Booked: 'Completed', Scheduled: 'Completed' })
    ).filter(Boolean) ?? []),
  ].filter(Boolean); // Remove any null/undefined alerts

  const { scenario } = useScenario()
  const operateMode = isOperateMode(dashboard, scenario)
  return (
    <div className={`alert__section__container ${operateMode ? 'show__alert' : 'd-none'}`}>
      {/* commenting this as it will be comming future */}
      {/* <Fragment>
        {notifications.map((noti, index) => (
          <div
            className={`notification__card ${noti.status === 'Error' && 'justify-content-between'}`}
            key={index}
          >
            <div className="d-flex gap-2 align-items-center justify-content-center">
              <div
                className={`status__indicator ${noti.status === 'Error' ? 'status__error' : 'status__schedule'
                  }`}
              />
              <span>{noti.title}</span>
            </div>
            <button className={`${noti.status === 'Error' ? 'status__error' : 'd-none'}`}>
              View
            </button>
          </div>
        ))}
      </Fragment> */}
      {alerts?.map((alert, index) => {
        if (!alert) return null;
        
        return (
          <div className="alert__card" key={`alert-${index}`}>
            <div className="d-flex align-items-center justify-content-between w-100">
              <div className="d-flex align-items-center gap-2">
                <SatelliteIcon />
                <div className="d-flex flex-column w-100">
                  <div className="d-flex justify-content-start align-items-center gap-1">
                    <span title={alert.groundstation}>{truncateText(alert.groundstation)},</span>
                    <span title={alert.country}>{truncateText(alert.country)}</span>
                  </div>
                  <span className="alert__type__label">{alert.type}</span>
                </div>
              </div>
              <div className={`badge ${getStatusClass(alert.status)}`}>
                <div className={`status__indicator ${getStatusClass(alert.status)} 
                  ${['Error', 'Completed'].includes(alert.status) ? 'd-none' : ''}`}
                />
                <span>{alert.status === 'Not Scheduled' ? 'Empty' : alert.status}</span>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between w-100">
              <div className="badge">{alert.time}</div>
              <div className="badge">{`for ${alert.duration} mins`}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ContactAlert;